import { useLayoutEffect, useRef, useState } from "react";

/**
 * Whether the observed element is at least `minWidth` wide. False until the
 * first measurement, and only re-renders when the answer changes.
 */
export const useContainerBreakpoint = <T extends HTMLElement>(
  minWidth: number,
) => {
  const ref = useRef<T>(null);
  const [isWide, setIsWide] = useState(false);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver(([entry]) => {
      setIsWide(entry.contentRect.width >= minWidth);
    });
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [minWidth]);

  return [ref, isWide] as const;
};
